<template>
  <form-field
    :label="label"
    :validation-errors="validationErrors"
    :label-for="forId"
    :help-text="helpText"
  >

    <!-- https://buefy.org/documentation/input  -->
    <b-input
      v-cleave="mask"
      v-bind="$attrs"
      :value="value"
      :id="forId"
      type="tel"
      :size="size"
      expanded
      :placeholder="placeholder"
      @input="handleInput"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
    ></b-input>
    <slot name="after"></slot>
  </form-field>
</template>

<script>
  import FormField from "./FormField";
  import {FormFieldMixin} from "./FormField.mixin";

  export default {
    name: "FormFieldPhone",
    components: {FormField},
    mixins: [FormFieldMixin],
    props: {
      value: {},
      placeholder: {
        type: String
      },
      label: {
        type: String,
      },
      validationErrors: {
        type: [String, Array, undefined],
      },
      helpText: {
        type: String
      },
      size: {
        type: String,
        default: 'is-small'
      },
      requirePrefix: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        forId: this.$utils.generateClientId(),
        mask: {
          phone: true,
          phoneRegionCode: 'US',
          delimiter: '-',
          prefix: this.requirePrefix ? '1' : null
        }
      }
    },
    methods: {
      handleInput(val) {
        this.$emit('input', val);
        this.$emit('change', val);
        this.$emit('selected', val);

        this.emitGlobalFieldChangeEvent();
      },
    }
  }
</script>

<style lang="scss" scoped>
// Due to how Buefy works these styles must be in global styles
</style>
